import useObjectState from "~utils/use-object-state"

const DEFAULT_PAYMENT_METHOD_STATE = {
    paymentMethodId: null,
    isExternalPaymentMethod: false,
    isAchPaymentMethod: false,
}

export interface PaymentMethodState {
    paymentMethodId: string | null
    isExternalPaymentMethod: boolean
    isAchPaymentMethod: boolean
}

export default function usePaymentMethodState() {
    const [paymentMethodState, updatePaymentMethodState] =
        useObjectState<PaymentMethodState>(DEFAULT_PAYMENT_METHOD_STATE)

    return { paymentMethodState, updatePaymentMethodState }
}
